import React from 'react'
import PropTypes from 'prop-types'
import { pure } from 'recompose'
import ExternalLink from './external-link'
import { get } from 'lodash'

const propTypes = {
  remove: PropTypes.func.isRequired,
  value: PropTypes.string,
}

const defaultProps = {}

function RemovableFile({ value, remove }) {
  // do not render if there are no value uploaded yet
  if (!value || get(value, '_destroy')) return null
  const filename = value.split('/').pop()

  return (
    <div className="file-name-preview">
      <div key={filename}>
        <ExternalLink href={value}>{filename}</ExternalLink>
        <button
          type="button"
          className="button-warn button-small"
          onClick={() => remove(value)}
        >
          Remove
        </button>
      </div>
    </div>
  )
}

RemovableFile.propTypes = propTypes
RemovableFile.defaultProps = defaultProps

export default pure(RemovableFile)
